module.exports = __webpack_public_path__ + "static/img/tianyukeji.fdb6681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tianyukeji.png
// module id = o4fP
// module chunks = 26